import React, { PropsWithChildren } from "react";
import { BotDetailsContext } from "@shared/features/bots/BotDetails.context";
import { sharedLib } from "@shared/services/shared.service";
import { skipToken } from "@reduxjs/toolkit/query";

interface BotDetailsProviderProps extends PropsWithChildren {
  botId?: number;
  isChannelConfiguration?: boolean;
  isBacktesting?: boolean;
}

const BotDetailsProvider = ({
  botId,
  children,
  isChannelConfiguration,
  isBacktesting,
}: BotDetailsProviderProps) => {
  const getBotDataStatus = sharedLib.sharedApi.bots.useGetBotDataQuery(
    botId
      ? {
          dca_bot_id: botId,
          is_channel_configuration: isChannelConfiguration,
          is_backtesting: isBacktesting,
        }
      : skipToken
  );

  const { data: botData } = getBotDataStatus.currentData || {};

  const getBotMetadataStatus = sharedLib.sharedApi.bots.useGetBotMetadataQuery(
    botId
      ? {
          dca_bot_id: botId,
          is_channel_configuration: isChannelConfiguration,
          is_backtesting: isBacktesting,
        }
      : skipToken
  );
  const { currentData: botMetadata } = getBotMetadataStatus;

  const refetch = () => {
    try {
      getBotDataStatus.refetch();
    } catch {}
    try {
      getBotMetadataStatus.refetch();
    } catch {}
  };

  return (
    <BotDetailsContext.Provider
      value={{
        getBotDataStatus,
        botData,
        getBotMetadataStatus,
        botMetadata,
        isChannelConfiguration,
        botId,
        refetch,
        isLoading: getBotDataStatus.isLoading || getBotMetadataStatus.isLoading,
      }}
    >
      {children}
    </BotDetailsContext.Provider>
  );
};

export default BotDetailsProvider;
